import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'order_submission-first_purchase_placed-click';
/**
 * Send FB Pixel event when user places their first order
 */
export function trackOrderSubmissionFirstPurchasePlacedClick(pixelCustomDataParams) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        facebookPixelEvent: 'IfFirstPurchase',
        pixelCustomDataParams: pixelCustomDataParams,
    });
}
